import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Store } from '@ngrx/store';
import { NGXLogger } from 'ngx-logger';
import { Observable } from 'rxjs';
import { take } from 'rxjs/operators';
import { getDashboardsConfigState, getDashboardsState, getIsDirtyState, getselectedDashboard, State } from 'src/app/dashboards/state';
import { dashboard } from 'src/app/models';
import { DataTransferService } from 'src/app/services/services/data-transfer.service';
import * as mainActions from 'src/app/state/app.actions';
import { dashboardConfig } from '../models';
import * as actions from './../state/actions';


@Component({
    selector: 'app-dashboard',
    templateUrl: './dashboard.component.html',
    styleUrls: ['./dashboard.component.scss'],
    standalone: false
})
export class DashboardComponent implements OnInit {
  dashboards: Observable<dashboard[]>;
  isDirtyState:Observable<boolean>;
  selectedDashboard:Observable<number>; 
  config:Observable<dashboardConfig>;   

  constructor(private store: Store<State>,public dialog: MatDialog, private logger: NGXLogger, private dataTransfer:DataTransferService) {
    this.dashboards = this.store.select(getDashboardsState);
    this.isDirtyState = this.store.select(getIsDirtyState);
    this.selectedDashboard = this.store.select(getselectedDashboard); 
    this.config = this.store.select(getDashboardsConfigState);
    this.store.dispatch(mainActions.loadUserInfo());
  }

  ngOnInit(): void {
    this.config.pipe(take(1)).subscribe(config=>{
      if(config.isDefault){
        this.store.dispatch(actions.loadDashboardConfig()); 
      }
    });
       
    this.isDirtyState.pipe(take(1)).subscribe(isDirtyState => {
      if (!isDirtyState) {
        this.getDashboards();
      }
    });

    if (this.dataTransfer.NewAddedWidgetId) {
      let id = this.dataTransfer.NewAddedWidgetId;
      this.dataTransfer.NewAddedWidgetId = undefined;
      setTimeout(() => {
        let newWidgerElement = document.getElementById('gridItem'+id);
        if(newWidgerElement) newWidgerElement.scrollIntoView();
      }, 500);
    }  
  }

  getDashboards(): void {
    this.logger.trace('DashboardComponent: getDashboards');
    this.store.dispatch(actions.loadDashboards());
  } 
}
